import React, { useState, useEffect } from 'react'
import './Marquee.css'

const Marquee = ({
  text = ['This is a scrolling marquee animation!'],
  speed = 15,
  direction = 'left',
}) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0)
  const animationDirection =
    direction === 'left' ? 'marquee-left' : 'marquee-right'

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentTextIndex(prevIndex => (prevIndex + 1) % text.length)
    }, speed * 1000)

    return () => clearTimeout(timer)
  }, [currentTextIndex, speed, text.length])

  return (
    <div className="marquee">
      <p
        key={currentTextIndex}
        className={animationDirection}
        style={{
          animationDuration: `${speed}s`,
        }}>
        {text[currentTextIndex]}
      </p>
    </div>
  )
}

export default Marquee
